import React from 'react'
import styled from 'styled-components'

export const StyledComponent = styled(({...rest}) => <div {...rest} />)`

label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  span {
    font-size: 12px;
    height: 12px;
  }

  input {
    padding: 1px 4px;
    height: 29px;
    width: 172px;
    font-size: 12px;
  }
}

.anticon {
  margin-bottom: 5px;
}

`

const _Page_Header_User_ViewAs_styled = (props) => <StyledComponent {...props} />
_Page_Header_User_ViewAs_styled.propTypes = {}
_Page_Header_User_ViewAs_styled.className = StyledComponent

export default _Page_Header_User_ViewAs_styled

